export const ON_IMAGE = 'on_image';
export const NONE = 'none';
export const TITLE_DISCOUNT = 'title_discount';
export const YOU_TUBE = 'youtube';
export const getDetailsClass = (textPosition) => {
    const detailsClass = (textPosition === ON_IMAGE) ? 'titles-description-sticky' : 'titles-description';
    return detailsClass;
};
export const isTextVisible = (params) => {
    const { title, discountTitle, textPosition, description, subDescription, } = params;
    if ((textPosition && textPosition !== NONE)
        && (title || discountTitle || description || subDescription)) {
        return true;
    }
    return false;
};
export const isCalloutVisible = (params) => {
    const { callOut, callOut2, callOut3, } = params;
    if ((callOut !== NONE && callOut !== '' && callOut !== undefined) || (callOut2 !== NONE && callOut2 !== '' && callOut2 !== undefined) || (callOut3 !== NONE && callOut3 !== '' && callOut3 !== undefined)) {
        return true;
    }
    return false;
};
export const isTagTypeVisible = (params) => {
    const { tagType, } = params;
    if (tagType !== NONE && tagType !== undefined) {
        return true;
    }
    return false;
};
export const isTagTypeTimer = (params) => {
    const { tagType, } = params;
    if (tagType !== NONE && tagType !== undefined && tagType === 'timer') {
        return true;
    }
    return false;
};
export const isTagTypeText = (params, tagtype) => {
    const { tagType, tagText, } = params;
    if (tagType !== NONE && tagType !== undefined && tagType === tagtype
        && tagText !== NONE && tagText !== undefined && tagText !== '') {
        return true;
    }
    return false;
};
export const isTitleFirst = (titleOrder) => !(titleOrder === TITLE_DISCOUNT);
export const isVideoType = (actionType) => (actionType === YOU_TUBE);
